import { SxProps, Theme } from "@mui/material/styles";

export const statisticsContainer: SxProps<Theme> = (theme) => ({
    paddingLeft: theme.spacing(4),
    marginBottom: theme.spacing(4),
    backgroundColor: theme.palette.background.default,
    textAlign: "left",
    position: "relative",
});

export const contentWrapper: SxProps<Theme> = (theme) => ({
    position: "relative",
});

export const statisticBox: SxProps<Theme> = (theme) => ({
    marginBottom: theme.spacing(4),
    padding: theme.spacing(2),
    position: "relative",
    zIndex: 1,
});

export const statisticName: SxProps<Theme> = (theme) => ({
    color: theme.palette.text.primary,
    fontSize: "1.2rem",
    fontWeight: "bold",
});

export const statisticValue: SxProps<Theme> = (theme) => ({
    color: theme.palette.primary.main,
    fontWeight: "bold",
    fontSize: "2.5rem",
    marginBottom: theme.spacing(1),
});

export const statisticDescription: SxProps<Theme> = (theme) => ({
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
});

export const lottieWrapper: SxProps<Theme> = (theme) => ({
    position: "absolute",
    top: "0", // Keep it aligned at the top
    right: "0", // Align to the maximum right
    zIndex: 0, // Ensure it is behind the statistics content
});

export const lottieWrapperSecond: SxProps<Theme> = (theme) => ({
    position: "absolute",
    top: "50%", // Adjust based on the location of the 4th statistic
    right: "0", // Align to the maximum right
    transform: "translateY(-50%)", // Adjust to vertically center
    zIndex: 0, // Ensure it is behind the statistics content
});
